import { render, staticRenderFns } from "./PeerReviewInformation.vue?vue&type=template&id=8b663dfc"
import script from "./PeerReviewInformation.vue?vue&type=script&lang=js"
export * from "./PeerReviewInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports